export default __webpack_public_path__ + "static/media/40.336b8996.jpg";